import { useCallback, useState } from 'react';
import { Quiz } from 'shared/components/Quiz';
import { useDoorContent } from 'shared/hooks';
import { QUIZ, RESULT_QUIZ } from './constants';
import { EAdventDoorsHashs } from 'shared/types/doors';
import { TQuizResult } from 'shared/types/quiz';
import { getMostFrequentNumber } from 'shared/utils/getMostFrequentNumber/getMostFrequentNumber';
import { QuizResult } from 'shared/components/QuizResult';
import { SIXTH_GIFT_DOOR_LINK } from 'shared/constants/links';

export const AdventQuizContainer: React.FC = () => {
  const { handleClickBtn, isLoading } = useDoorContent({
    doorCode: EAdventDoorsHashs.SixthDoor,
    giftLink: SIXTH_GIFT_DOOR_LINK,
  });

  const [currentStep, setCurrentStep] = useState<number>(0);

  const [selectedValue, setSelectedValue] = useState<number>();

  const [allValues, setAllValues] = useState<number[]>([]);

  const [resultQuiz, setResultQuiz] = useState<TQuizResult>();

  const handleChangeStep = useCallback(async () => {
    if (currentStep < QUIZ.length - 1) {
      setSelectedValue(undefined);

      setAllValues(prev => [...prev, Number(selectedValue)]);

      setCurrentStep(prev => prev + 1);
    } else {
      setResultQuiz(RESULT_QUIZ[getMostFrequentNumber([...allValues, Number(selectedValue)]) - 1]);
    }
  }, [allValues, currentStep, selectedValue]);

  const handleChangeSelectedValue = useCallback((value: number) => {
    setSelectedValue(value);
  }, []);

  if (resultQuiz) {
    return <QuizResult isLoading={isLoading} {...resultQuiz} onBtn={handleClickBtn} />;
  }

  return (
    <Quiz
      selectedAnswer={selectedValue}
      quizItem={QUIZ[currentStep]}
      onBtnQuiz={handleChangeStep}
      onChangeSelectedAnswer={handleChangeSelectedValue}
    />
  );
};
